module.exports = __webpack_public_path__ + "img/Consultation2.90451b26.png";